import { createSlice } from "@reduxjs/toolkit";
import { defaultState } from "../../../../interfaces/auth";
import { getDivisionThunk } from "../../../../asyncThunks/manage/setups";

const initialState: defaultState = {
    error: null,
    data: [],
    loading: false,
};

export const getDivision = createSlice({
    name: "getDivision",
    initialState,
    reducers: {
        updateDivisionData: (state, action) => {
            const updatedDivision = action.payload;
            if (state.data) {
                const index = state.data?.divisions?.findIndex((divisions: { _id: any; }) => divisions._id === updatedDivision._id);
                if (index !== -1) {
                    state.data.divisions[index] = updatedDivision;
                }
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getDivisionThunk.pending, (state, action) => {
            state.error = null;
            // state.data = null;
            state.loading = true;
        });
        builder.addCase(getDivisionThunk.fulfilled, (state, action) => {
            if (action?.payload?.status?.toLowerCase() === "success") {
                state.error = null;
                state.data = action?.payload?.data;
            } else {
                state.error = action?.payload;
                state.data = [];
            }
            state.loading = false;
        });
        builder.addCase(getDivisionThunk.rejected, (state, action) => {
            state.error = action.payload;
            state.data = [];
            state.loading = false;
        });
    },
});

export const { updateDivisionData } = getDivision.actions;

export default getDivision.reducer;
